<div class="pageheader">
    <div class="page-title">
        <h1>Monitor groups</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">
                <span>Refresh</span>
                <ep-svg-icon icon="repeat"></ep-svg-icon>
            </button>
            <app-change-log-link *bizPermissionRequired="'Monitor_Action_ShowLog'" [title]="'Monitor groups log'">
                <app-change-log-link-entity type="MonitorGroup"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<app-monitor-groups-grid #grid [groups]="monitorGroups" (saveGroup)="onSaveGroup($event)"
    (deleteGroup)="onDeleteGroup($event)">
</app-monitor-groups-grid>
